<script setup lang="ts">
import type {
  JournalEditionDTO,
  JournalEditionShortDTO,
} from '~/shared/api/client/journals/journals.dto';
import {
  getJournalEditionUrl,
  getJournalTabEditions,
  getJournalTabUrl,
} from '~/shared/lib/journal-routes.const';
import type { JournalChip } from '../lib/journal.const';
import { useJournalEditions } from '../lib/useJournalData';
import JournalChips from './JournalChips.vue';

const props = defineProps<{
  active: JournalEditionShortDTO | null;
  tab: JournalEditionDTO;
}>();

const { editions: reference } = await useJournalEditions();

const chips = computed<JournalChip[]>(() => [
  {
    // Back to the tab this chip row belongs to, not to the section root:
    // leaving an archive edition has to stay on "Архив"
    key: 'all',
    label: 'Все',
    to: getJournalTabUrl(reference.value, props.tab),
    active: !props.active,
  },
  ...getJournalTabEditions(reference.value, props.tab).map((edition) => ({
    key: edition.id,
    label: edition.name,
    to: getJournalEditionUrl(reference.value, edition),
    active: edition.id === props.active?.id,
  })),
]);
</script>

<template>
  <JournalChips :items="chips" />
</template>
